import { getVisualsForType, themeMap } from "../plan/planTheme";

// Splits the flattened list into what the session sheet draws (#168): a
// superset is a heading over one card of its steps, a lone step is a card of
// its own, and a setup or transition between them is a divider. The root
// group is the session itself, already the sheet's title, so it's dropped.
export const toBlocks = (rows) => {
  const blocks = [];
  let group = null;
  for (const ex of rows) {
    if (ex.isGroup && ex.depth === 0) continue;
    if (ex.depth <= 1) {
      group = null;
      if (ex.isGroup) {
        group = { kind: "group", ex, rows: [] };
        blocks.push(group);
      } else if (
        getVisualsForType(ex.type, ex.label).theme === themeMap.Transition
      ) {
        blocks.push({ kind: "divider", ex });
      } else {
        blocks.push({ kind: "single", rows: [ex] });
      }
    } else if (group) {
      group.rows.push(ex);
    } else {
      blocks.push({ kind: "single", rows: [ex] });
    }
  }
  return blocks;
};
